import React, { useState } from 'react';
import { Search } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { Input } from './ui/input';
import { faqData } from '../data/mock';

export const FAQWithSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredFaqs, setFilteredFaqs] = useState(faqData);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === '') {
      setFilteredFaqs(faqData);
    } else {
      const filtered = faqData.filter(
        (faq) =>
          faq.question.toLowerCase().includes(term) ||
          faq.answer.toLowerCase().includes(term)
      );
      setFilteredFaqs(filtered);
    }
  };

  return (
    <section id="faq" className="py-20 bg-atob-blue">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <span className="text-atob-orange font-semibold text-sm uppercase tracking-wide mb-4 block">
              Häufig gestellte Fragen
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              Alles, was Sie wissen müssen
            </h2>
            <p className="text-lg text-gray-300 mb-8">
              Hier finden Sie Antworten auf die häufigsten Fragen rund um unsere Beratung
              und unser Netzwerk. Sollten Sie weitere Fragen haben, kontaktieren Sie uns gerne.
            </p>

            {/* Search Box */}
            <div className="max-w-2xl mx-auto relative">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
              <Input
                type="text"
                placeholder="Durchsuchen Sie die FAQs..."
                value={searchTerm}
                onChange={handleSearch}
                className="pl-12 py-6 text-lg border-2 border-gray-700 bg-transparent text-white placeholder:text-gray-400 focus:border-atob-orange"
              />
            </div>

            {/* Search Results Info */}
            {searchTerm && (
              <p className="mt-4 text-sm text-gray-300">
                {filteredFaqs.length} {filteredFaqs.length === 1 ? 'Ergebnis' : 'Ergebnisse'} gefunden
              </p>
            )}
          </div>

          {/* FAQ Accordion */}
          {filteredFaqs.length > 0 ? (
            <Accordion type="single" collapsible className="w-full space-y-4">
              {filteredFaqs.map((faq) => (
                <AccordionItem 
                  key={faq.id} 
                  value={`item-${faq.id}`}
                  className="bg-white border-2 border-gray-200 rounded-xl px-6 hover:border-atob-orange/30 transition-colors duration-200"
                >
                  <AccordionTrigger className="text-left font-semibold text-atob-blue hover:text-atob-orange">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 text-base">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          ) : (
            <div className="text-center py-12">
              <p className="text-gray-600 text-lg mb-4">
                Keine Ergebnisse für "{searchTerm}" gefunden.
              </p>
              <button
                onClick={() => {
                  setSearchTerm('');
                  setFilteredFaqs(faqData);
                }}
                className="text-atob-orange hover:underline font-semibold"
              >
                Alle FAQs anzeigen
              </button>
            </div>
          )}

          {/* Still have questions CTA */}
          <div className="mt-12 text-center bg-white rounded-2xl p-8 shadow-md">
            <h3 className="text-2xl font-bold text-atob-blue mb-3">
              Noch Fragen?
            </h3>
            <p className="text-gray-600 mb-6">
              Unser Team steht Ihnen gerne für ein persönliches Gespräch zur Verfügung.
            </p>
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-atob-orange hover:bg-atob-orange/90 text-white font-semibold px-8 py-3 rounded-lg transition-colors duration-200"
            >
              Jetzt Kontakt aufnehmen
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
